import axios from "axios"

export enum SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  TRIALING = 'TRIALING',
  EXPIRED = 'EXPIRED'
}

export interface Subscription {
  id: string
  companyId: string
  version: number
  startDate: string
  endDate?: string
  status: SubscriptionStatus
  createdAt: string
  createdByUsername: string
  cancelAtPeriodEnd: boolean
}

export interface CreateSubscriptionRequest {
  startDate: string
  endDate?: string
  status?: SubscriptionStatus
}

export interface UpdateSubscriptionRequest {
  startDate?: string
  endDate?: string
  status?: SubscriptionStatus
  makeEndless?: boolean
}

export async function getCompanySubscription (companyId: string): Promise<Subscription | null> {
  try {
    const response = await axios.get<Subscription>(`/api/admin/companies/${companyId}/subscription`)
    return {
      ...response.data,
      id: response.data.companyId
    }
  } catch (error: any) {
    if (error.response?.status === 404) {
      return null
    }
    throw error
  }
}

export async function createSubscription (companyId: string, request: CreateSubscriptionRequest): Promise<Subscription> {
  const response = await axios.post<Subscription>(`/api/admin/companies/${companyId}/subscription`, request)
  return {
    ...response.data,
    id: response.data.companyId
  }
}

export async function updateSubscription (
  companyId: string,
  request: UpdateSubscriptionRequest
): Promise<Subscription> {
  const response = await axios.put<Subscription>(`/api/admin/companies/${companyId}/subscription`, request)
  return {
    ...response.data,
    id: response.data.companyId
  }
}

export async function getSubscriptionHistory (companyId: string): Promise<Subscription[]> {
  const response = await axios.get<Subscription[]>(`/api/admin/companies/${companyId}/subscription/history`)
  return response.data.map(subscription => ({
    ...subscription,
    id: subscription.companyId
  }))
}

export interface SubscriptionListParams {
  companyId?: string
  status?: SubscriptionStatus
  _limit?: number
  _offset?: number
}
